// import React from 'react'

const convertPoints = (value, fixed) => {
  const number = parseFloat(value)

  return number
    .toFixed(fixed)
    .replace('.', ',')
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
}

const Currency = ({ value, decimalPlaces, name }) =>
  convertPoints(value, decimalPlaces) + ' ' + name

export default Currency



// WEBPACK FOOTER //
// ./src/Catalog/Availability/PriceLabel/Currency.js